export enum ROUTES {
  DASHBOARD = '/',
  LOGIN = '/login',
  ROUTE = '/route',
  SELECTED_ROUTE = '/route/:placeId',
  PLACES = '/place',
  ORDERS = '/orders',
  ORDER = '/order/:orderId',
  ORDER_INFO = '/order/:orderId/info',
  ORDER_CONTACT = '/place/:placeId/contact',
  ORDER_FULFILMENT = '/order/:orderId/fulfilment/:partId',
  ORDER_PRODUCT = '/order/:orderId/products/:partId',
  ORDER_ACTIVITY = '/order/:orderId/events/:partId',
  TEMP_TEST = '/testing',
}

export enum PRODUCTROUTES {
  PRODUCT = '/product/:masterProductId',
  DESCRIPTIVE_INFO = '/product/:masterProductId/descriptive-information',
  RAW_DATA = '/product/:masterProductId/raw-data',
  SEARCH_SETTINGS = '/product/:masterProductId/search-settings',
  SALES_INFO = '/product/:masterProductId/sales-information',
  PACKAGING_INFO = '/product/:masterProductId/packaging-information',
  NUTRITIONAL_INFO = '/product/:masterProductId/nutritional-information',
  ADDITIONAL_INFO = '/product/:masterProductId/additional-information',
  RELATED_PRODUCTS = '/product/:masterProductId/related-products',
}

export enum SIDEBARROUTES {
  PRODUCT = '/product',
  ORDER = '/order',
  ROUTE = '/route',
  PLACE = '/place',
  SEARCH = '/search-configuration',
}

export enum PLACEMAINROUTES {
  INFO = '/place/:placeId/info',
  CONTACT = '/place/:placeId/contact',
  FULFILMENT = '/place/:placeId/fulfilment',
  PAYMENT = '/place/:placeId/payment',
  SERVICEAREAS = 'place/:placeId/service-areas',
  DATA_EXTENSION = '/place/:placeId/extensions',
}
